import { render, staticRenderFns } from "./TagCountConsolidated.vue?vue&type=template&id=04a85aa2"
import script from "./TagCountConsolidated.vue?vue&type=script&lang=js"
export * from "./TagCountConsolidated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports